import { render } from "./currentSituationBoard.vue?vue&type=template&id=1840af33"
import script from "./currentSituationBoard.vue?vue&type=script&lang=js"
export * from "./currentSituationBoard.vue?vue&type=script&lang=js"

import "./currentSituationBoard.vue?vue&type=style&index=0&id=1840af33&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__